/**
 * Check string for newlines, if they exist wrap in quotes
 * @param  {string} st string to check
 * @return {string}    string wrapped in quotes
 */
export default function escapeNewLines(str) {
  return ('string' === typeof str && str.match('\n|\r')) ?
    str.replace(/[\r\n]+/gm, ' ') :
    str;
}



// WEBPACK FOOTER //
// ./app/utils/string/escapeNewLines.js